<template>
  <div
    :class="[
      'watermark bg-black text-white border-radius-8 flex no-wrap items-center text-uppercase cursor-pointer',
      small ? 'small q-px-sm' : 'q-px-md',
    ]"
    @click="goToLanding"
  >
    <span :class="['q-mr-sm', small ? 'fs-6' : 'fs-8']">{{ $t('text.createdBy') }}</span>
    <q-img
      src="/logo-white.svg"
      :width="small ? '76px' : '102px'"
      :height="small ? '19px' : '25px'"
    />
  </div>
</template>

<script setup>
defineProps({
  small: {
    type: Boolean,
    default: false,
  },
});

function goToLanding() {
  window.open(process.env.LANDING_HOST, '_blank');
}
</script>

<style lang="scss" scoped>
.watermark {
  height: 41px;
  width: fit-content;

  &.small {
    height: 31px;
  }
}
</style>
